import { createApp } from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";

axios.defaults.withCredentials = true;
import { createPinia } from "pinia"; // Pinia
import "@/assets/tailwind.css";
import faviconUrl from "@/assets/va_logo.png";

(() => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;
})();
// import "@fontsource/poppins/400.css";
// import "@fontsource/poppins/500.css";
// import "@fontsource/poppins/600.css";
// import "@fontsource/poppins/700.css";

import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// ✅ Vue3 Toastify
import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const app = createApp(App);

// Create Pinia instance
const pinia = createPinia();

// Use Pinia and router
app.use(pinia);
app.use(router);

// Use Toastify
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: "top-right",
});

app.mount("#app");

export { toast };
